import React from "react";
import ProductCard from "./product_card";

const BestSeller = () => {
  const products = [
    {
      name: "Windows POS",
      image:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fnext%2Fitems%2F1674033810642df5a258e7dac100484e3c63e10728304?alt=media&token=ed8ccb4c-8a62-472b-b17c-e4a3d473e452",
      link: "https://nextgadgetshop.com/product/clauswmp68287401s68wcziu47",
    },
    {
      name: "Power Bank",
      image:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fnext%2Fitems%2F16722898540061008ea38db87cb7d2eb597c1ce948161?alt=media&token=8562a77b-f31c-43d1-bee4-07a04635370f",
      link: "https://nextgadgetshop.com/product/clc8m8qpf16336501s6u209j6gf",
    },
    {
      name: "Thermal Printer",
      image:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fnext%2Fitems%2F1669384047320c6c24711faf2e049a77c97bba4ce2fae?alt=media&token=1162b7ee-f612-4665-b60e-4604573a6744",
      link: "https://nextgadgetshop.com/product/clawk7xds13580501s683xq1frl",
    },
    {
      name: "Phone Cover",
      image:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fnext%2Fitems%2F1671970149467e68b1dd2848e87cc132bc732b19b8695?alt=media&token=093032fa-0891-405c-874a-e342af1f12e2",
      link: "https://nextgadgetshop.com/product/clcbjzlbj7086401s67v37nozo",
    },
    {
      name: "Headphones",
      image:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fnext%2Fitems%2F167231431205795b79804ca589bfec5e791267397ab87?alt=media&token=3bd50fd8-68f5-4fbb-b51b-4a15a965c93d",
      link: "https://nextgadgetshop.com/product/clc90thj14305201s641xoqjuj",
    },
    {
      name: "Charging Cables",
      image:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fnext%2Fitems%2F16698726482990a2da9791a1e119adea8949d48b2d5a0?alt=media&token=61c62326-cdcf-4ff4-9a13-98b208f096a8",
      link: "https://nextgadgetshop.com/product/clbkenyps1685701s6a8ml4hth",
    },
    {
      name: "Barcode Scanner",
      image:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fnext%2Fitems%2F-NOcclb86ih2-kDVJu3b?alt=media&token=1c3a7b16-9e74-4500-b061-2d5488be0040",
      link: "https://nextgadgetshop.com/product/cleb367bt853701s6q1l1p9x1",
    },
    {
      name: "Keyboard & Mouse",
      image:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fnext%2Fitems%2F1672135996617263718300c67f3d9e246d360b3b7fa87?alt=media&token=c594cf95-77f8-47a9-80dc-8b78c6ed30b6",
      link: "https://nextgadgetshop.com/product/clc62oie13572101s6ds36zrk9",
    },
  ];


  return (
    <div className="pt-10">
      <h1 className="text-4xl text-gray-700 font-bold text-center">Products</h1>
      <div className="flex justify-center items-center gap-5 flex-wrap my-10">
        {products?.map((item, i) => (
          <a href={item.link}>
            <ProductCard key={i} item={item} />
          </a>
        ))}
      </div>
    </div>
  );
};

export default BestSeller;
